export default "__VITE_ASSET__CT12UPOw__"